<span mat-dialog-title>
  Crear registro
  <br />
  <p class="tw-text-lg">¿De cuantas piezas es la cantidad de tu lote?</p>
</span>
<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onClickSave()">
    <mat-form-field appearance="fill" class="tw-w-full">
      <mat-label>Cantidad del lote</mat-label>
      <input
        matInput
        required
        [min]="minQuantity"
        [max]="data.maxQuantity"
        type="number"
        name="quantity"
        formControlName="quantity"
      />
    </mat-form-field>
    <mat-form-field appearance="fill" class="tw-w-full" *ngIf="showShifts">
      <mat-label>Turno</mat-label>
      <mat-select formControlName="shift" class="tw-w-full">
        <mat-option *ngFor="let item of shifts" [value]="item.id"
          >{{ item.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    type="button"
    (click)="onClickClose()"
    class="app-btn-close"
  >
    Cerrar
  </button>
  <button
    class="app-btn-save"
    mat-raised-button
    [disabled]="!form.valid"
    (click)="onClickSave()"
  >
    Guardar
  </button>
</mat-dialog-actions>
